import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import ErrorBoundary from '../ErrorBoundary';
import Topbar from './Topbar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import TopMenuNav from './TopMenuNav';
import { useOfficeSidebarItems } from './useOfficeSidebarItems';
import ModuleGuard from '../ModuleGuard';
import { useTheme } from '../../contexts/ThemeContext';
import { useSettings } from '../../contexts/SettingsContext';
import { useEffectiveSidebarLayout } from '../../hooks/useEffectiveSidebarLayout';
import { usesSidebar, usesTopMenu } from '../../config/sidebarLayout';
import { useAuth } from '../../contexts/AuthContext';
import { cn } from '../../lib/utils';
import { getBookmarks, getCachedBookmarks, reconstructBookmarkIcon, BookmarkItem } from '../../utils/bookmarks';
import {
  applySidebarLayout,
  fetchSidebarLayout,
  getCachedSidebarLayout,
  type SidebarLayout,
} from '../../utils/sidebarLayout';
import UserThemeSync from '../../modules/account-settings/UserThemeSync';
import { moduleConfig as accountSettingsConfig } from '../../modules/account-settings/config';
import { moduleConfig as usersConfig } from '../../modules/admin/users/config';
import { moduleConfig as itemUnitsConfig } from '../../modules/supplies/item-units/config';
import { moduleConfig as itemsConfig } from '../../modules/supplies/items/config';
import { moduleConfig as supplyCasesConfig } from '../../modules/supplies/supply-cases/config';
import { moduleConfig as requisitionsConfig } from '../../modules/supplies/requisitions/requisitionsModuleConfig';
import { moduleConfig as supplierEnquiriesConfig } from '../../modules/supplies/supplier-enquiries/supplierEnquiriesModuleConfig';
import { moduleConfig as supplierQuotationsConfig } from '../../modules/supplies/supplier-quotations/supplierQuotationsModuleConfig';
import { moduleConfig as supplyDeliveriesConfig } from '../../modules/supplies/supply-deliveries/supplyDeliveriesModuleConfig';
import { moduleConfig as supplyPurchaseOrdersConfig } from '../../modules/supplies/supply-purchase-orders/supplyPurchaseOrdersModuleConfig';
import { moduleConfig as supplyForwardingStatusesConfig } from '../../modules/supplies/supply-forwarding-statuses/config';
import { moduleConfig as supplyForwardingsConfig } from '../../modules/supplies/supply-forwardings/supplyForwardingsModuleConfig';
import { moduleConfig as supplyInvoicesConfig } from '../../modules/supplies/supply-invoices/supplyInvoicesModuleConfig';
import { moduleConfig as quotationEvaluationsConfig } from '../../modules/supplies/quotation-evaluations/quotationEvaluationsModuleConfig';
import { moduleConfig as spareCasesConfig } from '../../modules/spares/spare-cases/config';
import { moduleConfig as spareRequisitionsConfig } from '../../modules/spares/requisitions/requisitionsModuleConfig';
import { moduleConfig as spareSupplierEnquiriesConfig } from '../../modules/spares/supplier-enquiries/supplierEnquiriesModuleConfig';
import { moduleConfig as spareSupplierQuotationsConfig } from '../../modules/spares/supplier-quotations/supplierQuotationsModuleConfig';
import { moduleConfig as spareDeliveriesConfig } from '../../modules/spares/spare-deliveries/spareDeliveriesModuleConfig';
import { moduleConfig as sparePurchaseOrdersConfig } from '../../modules/spares/spare-purchase-orders/sparePurchaseOrdersModuleConfig';
import { moduleConfig as spareForwardingStatusesConfig } from '../../modules/spares/spare-forwarding-statuses/config';
import { moduleConfig as pmsDomainConfig0 } from '../../modules/pms/pms-departments/config';
import { moduleConfig as pmsDomainConfig1 } from '../../modules/pms/pms-equipment-systems/config';
import { moduleConfig as pmsDomainConfig2 } from '../../modules/pms/pms-components/config';
import { moduleConfig as pmsDomainConfig3 } from '../../modules/pms/pms-sub-components/config';
import { moduleConfig as pmsDomainConfig4 } from '../../modules/pms/pms-equipment/config';
import { moduleConfig as pmsDomainConfig5 } from '../../modules/pms/pms-equipment-instances/config';
import { moduleConfig as pmsDomainConfig6 } from '../../modules/pms/pms-maintenance-jobs/config';
import { moduleConfig as pmsDomainConfig7 } from '../../modules/pms/pms-maintenance-counters/config';
import { moduleConfig as pmsDomainConfig8 } from '../../modules/pms/pms-work-orders/config';
import { moduleConfig as pmsDomainConfig9 } from '../../modules/pms/pms-defects/config';
import { moduleConfig as noonReportsConfig } from '../../modules/operations/noon-reports/config';
import { moduleConfig as pmsDomainConfig11 } from '../../modules/pms/pms-tools/config';
import { moduleConfig as pmsDomainConfig13 } from '../../modules/pms/pms-documents/config';
import { moduleConfig as pmsLookupConfig0 } from '../../modules/pms/pms-record-statuses/config';
import { moduleConfig as pmsLookupConfig1 } from '../../modules/pms/pms-criticalities/config';
import { moduleConfig as pmsLookupConfig2 } from '../../modules/pms/pms-equipment-statuses/config';
import { moduleConfig as pmsLookupConfig3 } from '../../modules/pms/pms-maintenance-strategies/config';
import { moduleConfig as pmsLookupConfig4 } from '../../modules/pms/pms-job-types/config';
import { moduleConfig as pmsLookupConfig5 } from '../../modules/pms/pms-schedule-types/config';
import { moduleConfig as pmsLookupConfig6 } from '../../modules/pms/pms-interval-units/config';
import { moduleConfig as pmsLookupConfig7 } from '../../modules/pms/pms-work-order-statuses/config';
import { moduleConfig as pmsLookupConfig8 } from '../../modules/pms/pms-work-order-sources/config';
import { moduleConfig as pmsLookupConfig9 } from '../../modules/pms/pms-approval-statuses/config';
import { moduleConfig as pmsLookupConfig10 } from '../../modules/pms/pms-step-statuses/config';
import { moduleConfig as pmsLookupConfig11 } from '../../modules/pms/pms-counter-types/config';
import { moduleConfig as pmsLookupConfig12 } from '../../modules/pms/pms-counter-sources/config';
import { moduleConfig as pmsLookupConfig13 } from '../../modules/pms/pms-measurement-results/config';
import { moduleConfig as pmsLookupConfig14 } from '../../modules/pms/pms-defect-severities/config';
import { moduleConfig as pmsLookupConfig15 } from '../../modules/pms/pms-defect-statuses/config';
import { moduleConfig as pmsLookupConfig16 } from '../../modules/pms/pms-equipment-instance-statuses/config';
import { moduleConfig as pmsLookupConfig17 } from '../../modules/pms/pms-safety-requirement-types/config';
import { moduleConfig as pmsLookupConfig18 } from '../../modules/pms/pms-document-types/config';
import { moduleConfig as pmsLookupConfig19 } from '../../modules/pms/pms-verification-statuses/config';
import { moduleConfig as pmsLookupConfig20 } from '../../modules/pms/pms-department-types/config';
import { moduleConfig as spareForwardingsConfig } from '../../modules/spares/spare-forwardings/spareForwardingsModuleConfig';
import { moduleConfig as spareInvoicesConfig } from '../../modules/spares/spare-invoices/spareInvoicesModuleConfig';
import { moduleConfig as spareQuotationEvaluationsConfig } from '../../modules/spares/quotation-evaluations/quotationEvaluationsModuleConfig';
import { moduleConfig as spareLibrariesConfig } from '../../modules/spares/spare-libraries/config';
import { moduleConfig as spareItemsConfig } from '../../modules/spares/spare-items/config';
import { moduleConfig as countriesConfig } from '../../modules/parameters/countries/config';
import { moduleConfig as currenciesConfig } from '../../modules/parameters/currencies/config';
import { moduleConfig as departmentsConfig } from '../../modules/parameters/departments/config';
import { moduleConfig as storeCategoriesConfig } from '../../modules/parameters/store-categories/config';
import { moduleConfig as vesselsConfig } from '../../modules/parameters/vessels/config';
import { moduleConfig as portsConfig } from '../../modules/parameters/ports/config';
import { moduleConfig as entitiesConfig } from '../../modules/entities/config';
import { moduleConfig as crewConfig } from '../../modules/crew/config';
import { moduleConfig as mgaConfig } from '../../modules/mga/config';
import { moduleConfig as wrhConfig } from '../../modules/wrh/config';
import {
  buildCrewLookupModuleConfig,
  CREW_LOOKUP_DEFS,
  crewLookupListPath,
} from '../../modules/parameters/crew-lookups';
import { moduleConfig as accDocumentTypesConfig } from '../../modules/accounting/document-types/config';
import { moduleConfig as accAccountTypesConfig } from '../../modules/accounting/account-types/config';
import { moduleConfig as accOperationalTypesConfig } from '../../modules/accounting/operational-types/config';
import { moduleConfig as accCompaniesConfig } from '../../modules/accounting/companies/config';
import { moduleConfig as accAccountsConfig } from '../../modules/accounting/accounts/config';
import { moduleConfig as accPeriodsConfig } from '../../modules/accounting/periods/config';
import { moduleConfig as accCurrencyRatesConfig } from '../../modules/accounting/currency-rates/config';
import { moduleConfig as accDocumentsConfig } from '../../modules/accounting/documents/config';
import { moduleConfig as storeCatalogsConfig } from '../../modules/supplies/store-catalogs/config';
import { ACCOUNTING_REPORT_CATALOG } from '../../modules/accounting/reports/reportCatalog';

const accountingReportRoutes = Object.fromEntries(
  ACCOUNTING_REPORT_CATALOG.flatMap((group) =>
    group.reports.map((report) => [report.path, { module: { title: report.name } }])
  )
);

// Route to module config mapping (template: extend as you add modules)
const routeToConfigMap: Record<string, any> = {
  '/': { module: { title: 'Dashboard' } },
  '/dashboard': { module: { title: 'Dashboard' } },
  '/account-settings': accountSettingsConfig,
  '/approvals/templates': { module: { title: 'Approval templates' } },
  '/approvals/delegations': { module: { title: 'Delegations' } },
  '/approvals': { module: { title: 'Approvals Inbox' } },
  '/documents/business-rules': { module: { title: 'Document business rules' } },
  '/documents/new': { module: { title: 'New document' } },
  '/documents': { module: { title: 'Documents' } },
  '/parameters/countries': countriesConfig,
  '/parameters/currencies': currenciesConfig,
  '/parameters/departments': departmentsConfig,
  '/parameters/store-categories': storeCategoriesConfig,
  '/parameters/ports': portsConfig,
  '/parameters/vessels': vesselsConfig,
  '/entities': entitiesConfig,
  '/crew': crewConfig,
  '/mga': mgaConfig,
  '/wrh/sheet': { module: { title: 'WRH Month Sheet' } },
  '/wrh/sheet/rest-record': { module: { title: 'Record of Hours of Rest' } },
  '/wrh/arrangements': { module: { title: 'Crew Working Arrangements' } },
  '/wrh/arrangements/report': { module: { title: 'Working Arrangements Report' } },
  '/wrh/rules': { module: { title: 'WRH Rules' } },
  '/wrh/rules/report': { module: { title: 'WRH Rules Report' } },
  '/wrh/operation-types': { module: { title: 'Vessel Operation Types' } },
  '/wrh/operation-types/new': { module: { title: 'New operation type' } },
  '/wrh/operation-types/:id': { module: { title: 'Operation type' } },
  '/wrh/operation-types/:id/edit': { module: { title: 'Edit operation type' } },
  '/wrh/compliance': { module: { title: 'WRH Compliance' } },
  '/wrh/compliance/report': { module: { title: 'WRH Compliance Report' } },
  '/wrh/reports': { module: { title: 'WRH Weekly Report' } },
  '/wrh/reports/report': { module: { title: 'WRH Weekly Summary Report' } },
  '/wrh': wrhConfig,
  '/vessel-operations': { module: { title: 'Vessel Operations Schedule' } },
  '/vessel-operations/report': { module: { title: 'Vessel Operations Report' } },
  '/crew/list': { module: { title: 'Crew List' } },
  '/crew/list/print/imo': { module: { title: 'IMO Crew List' } },
  '/crew/list/print/onboard': { module: { title: 'Onboard Crew List' } },
  '/crew/list/print/wages': { module: { title: 'Crew Wages & Contracts' } },
  '/crew/list/imo-print': { module: { title: 'IMO Crew List' } },
  '/crew/officer-matrix': { module: { title: "Officer's Qualification Matrix" } },
  '/crew/rightship-matrix': { module: { title: 'RightShip Officers Qualifications Matrix' } },
  '/crew/changes-per-vessel': { module: { title: 'Total Crew Changes per Vessel' } },
  '/crew/certs-expiring': { module: { title: 'Certificate expiry' } },
  '/crew/certificate-requirements': { module: { title: 'Document Requirements' } },
  '/crew/rank-requirements': { module: { title: 'Document Requirements' } },
  '/crew/reports': { module: { title: 'Crew reports' } },
  '/crew/reports/operations/onboard': { module: { title: 'Onboard' } },
  '/crew/reports/operations/available': { module: { title: 'Available' } },
  '/crew/reports/operations/not-recommended': { module: { title: 'Not recommended' } },
  '/crew/reports/operations': { module: { title: 'Onboard' } },
  '/crew/statistics': { module: { title: 'Crew statistics' } },
  '/crew/statistics/onboard': { module: { title: 'Onboard' } },
  '/crew/statistics/onboard/print': { module: { title: 'Onboard counts' } },
  '/crew/statistics/available': { module: { title: 'Available' } },
  '/crew/statistics/available/print': { module: { title: 'Available counts' } },
  '/crew/statistics/not-recommended': { module: { title: 'Not recommended' } },
  '/crew/statistics/not-recommended/print': { module: { title: 'Not recommended counts' } },
  '/crew/statistics/nationalities': { module: { title: 'Nationalities' } },
  '/crew/reports/compliance/certs-expired': { module: { title: 'Certs expired' } },
  '/crew/reports/compliance/certs-expiring': { module: { title: 'Certs expiring' } },
  '/crew/reports/compliance/medicals-expired': { module: { title: 'Medicals expired' } },
  '/crew/reports/compliance/medicals-due': { module: { title: 'Medicals due soon' } },
  '/crew/reports/compliance/coe-soon': { module: { title: 'COE soon' } },
  '/crew/reports/compliance/intention-overdue': { module: { title: 'Intention overdue' } },
  '/crew/reports/compliance/nationalities': { module: { title: 'Nationalities' } },
  '/crew/reports/compliance': { module: { title: 'Certs expired' } },
  '/crew/statistics/compliance/certs-expired': { module: { title: 'Certs expired' } },
  '/crew/statistics/compliance/certs-expiring': { module: { title: 'Certs expiring' } },
  '/crew/statistics/compliance/medicals-expired': { module: { title: 'Medicals expired' } },
  '/crew/statistics/compliance/medicals-due': { module: { title: 'Medicals due soon' } },
  '/crew/statistics/compliance': { module: { title: 'Certs expired' } },
  '/crew/statistics/people-payroll/appraisals': { module: { title: 'Appraisals / NR set' } },
  '/crew/statistics/people-payroll/not-recommended': { module: { title: 'NR count' } },
  '/crew/statistics/people-payroll/avg-months-onboard': { module: { title: 'Avg months onboard' } },
  '/crew/statistics/people-payroll/contract-wages': { module: { title: 'Contract wage total' } },
  '/crew/statistics/people-payroll/allottees': { module: { title: 'Allottees' } },
  '/crew/statistics/people-payroll/allottee-amount': { module: { title: 'Allottee amount' } },
  '/crew/statistics/people-payroll': { module: { title: 'Appraisals / NR set' } },
  '/crew/statistics/mix/nationality': { module: { title: 'Nationality mix' } },
  '/crew/statistics/mix/rank': { module: { title: 'Rank mix' } },
  '/crew/statistics/mix/cert-expiry': { module: { title: 'Certificate expiry buckets' } },
  '/crew/statistics/mix': { module: { title: 'Nationality mix' } },
  '/crew/statistics/age/rank': { module: { title: 'Age — per rank' } },
  '/crew/statistics/age/rank-category': { module: { title: 'Age — per rank category' } },
  '/crew/statistics/age/vessel': { module: { title: 'Age — per vessel' } },
  '/crew/statistics/sign-off/rank': { module: { title: 'Sign-off — per rank' } },
  '/crew/statistics/sign-off/rank-category': { module: { title: 'Sign-off — per rank category' } },
  '/crew/statistics/sign-off/vessel': { module: { title: 'Sign-off — per vessel' } },
  '/crew/statistics/sign-on/rank': { module: { title: 'Sign-on — per rank' } },
  '/crew/statistics/sign-on/rank-category': { module: { title: 'Sign-on — per rank category' } },
  '/crew/statistics/sign-on/vessel': { module: { title: 'Sign-on — per vessel' } },
  '/crew/statistics/appraisal-grade/rank': { module: { title: 'Appraisal grade — per rank' } },
  '/crew/statistics/appraisal-grade/rank-category': { module: { title: 'Appraisal grade — per rank category' } },
  '/crew/statistics/appraisal-grade/vessel': { module: { title: 'Appraisal grade — per vessel' } },
  '/crew/cert-gaps': { module: { title: 'Document Gaps' } },
  '/crew/relief-board': { module: { title: 'Relief board' } },
  '/crew/coe-watchlist': { module: { title: 'COE watchlist' } },
  '/crew/appraisal-nr': { module: { title: 'Appraisals / NR' } },
  '/crew/wage-allottee': { module: { title: 'Wage / allottee' } },
  '/crew/previous-service': { module: { title: 'Previous service experience' } },
  '/crew/onboard-status': { module: { title: 'Onboard Status (AI)' } },
  '/crew/onboard-status/print': { module: { title: 'Onboard Status Print' } },
  '/crew/replacement-planner': { module: { title: 'Replacement planner' } },
  '/crew/crew-changes-cost': { module: { title: 'Crew Changes Cost' } },
  '/crew/crew-changes-cost/new': { module: { title: 'New Crew Changes Cost' } },
  '/crew/crew-changes-cost/:id': { module: { title: 'Crew Changes Cost' } },
  '/crew/crew-changes-cost/:id/edit': { module: { title: 'Edit Crew Changes Cost' } },
  '/parameters/crew': { module: { title: 'Human Resources' } },
  '/parameters/general': { module: { title: 'General reference data' } },
  '/parameters/purchasing': { module: { title: 'Purchasing' } },
  '/parameters/supplies-catalog': { module: { title: 'Purchasing' } },
  '/parameters/spares-catalog': { module: { title: 'Purchasing' } },
  '/parameters/pms': { module: { title: 'PMS reference data' } },
  '/parameters/finance': { module: { title: 'Finance' } },
  ...Object.fromEntries(
    CREW_LOOKUP_DEFS.map((def) => [crewLookupListPath(def.kind), buildCrewLookupModuleConfig(def)]),
  ),
  '/accounting/journal-types': accDocumentTypesConfig,
  '/accounting/account-types': accAccountTypesConfig,
  '/accounting/operational-types': accOperationalTypesConfig,
  '/accounting/companies': accCompaniesConfig,
  '/accounting/coa': accAccountsConfig,
  '/accounting/statement-lines': { module: { title: 'Statement lines' } },
  '/accounting/periods': accPeriodsConfig,
  '/accounting/currency-rates': accCurrencyRatesConfig,
  '/accounting/journals': accDocumentsConfig,
  '/accounting/invoices/new': {
    module: { title: 'New invoice' },
    form: { new: { title: 'New invoice' }, edit: { title: 'Edit invoice' } },
  },
  '/accounting/invoices': {
    module: { title: 'Invoice' },
    form: { new: { title: 'New invoice' }, edit: { title: 'Edit invoice' } },
  },
  '/accounting/payments/new': {
    module: { title: 'New payment' },
    form: { new: { title: 'New payment' }, edit: { title: 'Edit payment' } },
  },
  '/accounting/payments': {
    module: { title: 'Payment' },
    form: { new: { title: 'New payment' }, edit: { title: 'Edit payment' } },
  },
  '/accounting/reports': { module: { title: 'Accounting reports' } },
  '/accounting/reports/analytical-ledgers': { module: { title: 'Analytical ledgers' } },
  '/accounting/reports/journal': { module: { title: 'Journal' } },
  '/accounting/reports/ledger-kartela': { module: { title: 'Ledger details' } },
  '/accounting/reports/trial-balance': { module: { title: 'Trial balance' } },
  '/accounting/reports/aging': { module: { title: 'Aging' } },
  '/supplies/requisitions': requisitionsConfig,
  '/supplies/supplier-enquiries': supplierEnquiriesConfig,
  '/supplies/supplier-quotations': supplierQuotationsConfig,
  '/supplies/supply-deliveries': supplyDeliveriesConfig,
  '/supplies/supply-purchase-orders': supplyPurchaseOrdersConfig,
  '/supplies/supply-forwarding-statuses': supplyForwardingStatusesConfig,
  '/supplies/supply-forwardings': supplyForwardingsConfig,
  '/supplies/supply-invoices': supplyInvoicesConfig,
  '/supplies/quotation-evaluations': quotationEvaluationsConfig,
  '/supplies/supply-cases': supplyCasesConfig,
  '/port-calls': {
    module: { title: 'Port calls' },
  },
  '/forwardings': {
    module: { title: 'Forwardings' },
    detail: { subtitle: 'Shipment location across supplies & spares' },
  },
  '/supplies/port-calls': {
    module: { title: 'Port calls' },
  },
  '/supplies/items': itemsConfig,
  '/supplies/item-units': itemUnitsConfig,
  '/supplies/store-catalogs': storeCatalogsConfig,
  '/supplies/excel-document-templates': { module: { title: 'Excel document templates' } },
  '/system/reference-templates': { module: { title: 'Reference templates' } },
  '/system/mga-sheet-columns': { module: { title: 'MGA sheet columns' } },
  '/supplies/reference-templates': { module: { title: 'Reference templates' } },
  '/spares/requisitions': spareRequisitionsConfig,
  '/spares/supplier-enquiries': spareSupplierEnquiriesConfig,
  '/spares/supplier-quotations': spareSupplierQuotationsConfig,
  '/spares/spare-deliveries': spareDeliveriesConfig,
  '/spares/spare-purchase-orders': sparePurchaseOrdersConfig,
  '/spares/spare-forwarding-statuses': spareForwardingStatusesConfig,
  '/pms/pms-departments': pmsDomainConfig0,
  '/pms/pms-equipment-systems': pmsDomainConfig1,
  '/pms/pms-components': pmsDomainConfig2,
  '/pms/pms-sub-components': pmsDomainConfig3,
  '/pms/pms-equipment': pmsDomainConfig4,
  '/pms/pms-equipment-instances': pmsDomainConfig5,
  '/pms/pms-maintenance-jobs': pmsDomainConfig6,
  '/pms/pms-maintenance-counters': pmsDomainConfig7,
  '/pms/pms-work-orders': pmsDomainConfig8,
  '/pms/pms-defects': pmsDomainConfig9,
  '/operations/noon-reports': noonReportsConfig,
  '/pms/pms-tools': pmsDomainConfig11,
  '/pms/pms-documents': pmsDomainConfig13,
  '/pms/pms-record-statuses': pmsLookupConfig0,
  '/pms/pms-criticalities': pmsLookupConfig1,
  '/pms/pms-equipment-statuses': pmsLookupConfig2,
  '/pms/pms-maintenance-strategies': pmsLookupConfig3,
  '/pms/pms-job-types': pmsLookupConfig4,
  '/pms/pms-schedule-types': pmsLookupConfig5,
  '/pms/pms-interval-units': pmsLookupConfig6,
  '/pms/pms-work-order-statuses': pmsLookupConfig7,
  '/pms/pms-work-order-sources': pmsLookupConfig8,
  '/pms/pms-approval-statuses': pmsLookupConfig9,
  '/pms/pms-step-statuses': pmsLookupConfig10,
  '/pms/pms-counter-types': pmsLookupConfig11,
  '/pms/pms-counter-sources': pmsLookupConfig12,
  '/pms/pms-measurement-results': pmsLookupConfig13,
  '/pms/pms-defect-severities': pmsLookupConfig14,
  '/pms/pms-defect-statuses': pmsLookupConfig15,
  '/pms/pms-equipment-instance-statuses': pmsLookupConfig16,
  '/pms/pms-safety-requirement-types': pmsLookupConfig17,
  '/pms/pms-document-types': pmsLookupConfig18,
  '/pms/pms-verification-statuses': pmsLookupConfig19,
  '/pms/pms-department-types': pmsLookupConfig20,
  '/spares/spare-forwardings': spareForwardingsConfig,
  '/spares/spare-invoices': spareInvoicesConfig,
  '/spares/quotation-evaluations': spareQuotationEvaluationsConfig,
  '/spares/spare-cases': spareCasesConfig,
  '/spares/port-calls': {
    module: { title: 'Port calls' },
  },
  '/spares/spare-items': spareItemsConfig,
  '/spares/spare-libraries': spareLibrariesConfig,
  '/spares/reference-templates': { module: { title: 'Reference templates' } },
  '/admin/users': usersConfig,
  '/admin/manning-agents': { module: { title: 'Manning agents' } },
  '/admin/settings/application': { module: { title: 'Application settings' } },
  '/admin/ai-billing': { module: { title: 'AI billing' } },
  '/admin/import-actions/impa-code': { module: { title: 'IMPA Code import' } },
  '/admin/import-actions/accounts-plan': { module: { title: 'Chart of accounts import' } },
  '/admin/import-actions/companies': { module: { title: 'Companies import' } },
  '/admin/import-actions/journals': { module: { title: 'Journals import' } },
  '/admin/database-browser': { module: { title: 'Database browser' } },
  ...accountingReportRoutes,
};

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  const isCompact = false;
  const [isMobileOpen, setIsMobileOpen] = React.useState(false);
  const { appConfig } = useSettings();
  const sidebarStyle = useEffectiveSidebarLayout();
  const showSidebar = usesSidebar(sidebarStyle);
  const showTopMenu = usesTopMenu(sidebarStyle);
  const { user, can, permissionsLoaded } = useAuth();
  const canView = React.useMemo(
    () => (permissionsLoaded || user?.role === 'ADMIN' ? (moduleKey: string) => can(moduleKey, 'view') : undefined),
    [can, permissionsLoaded, user?.role]
  );
  const baseSidebarItems = useOfficeSidebarItems(canView);
  const [sidebarLayout, setSidebarLayout] = React.useState<SidebarLayout | null>(() => getCachedSidebarLayout());

  React.useEffect(() => {
    let cancelled = false;
    fetchSidebarLayout().then((layout) => {
      if (!cancelled) setSidebarLayout(layout);
    });
    const onUpdated = () => {
      setSidebarLayout(getCachedSidebarLayout());
      fetchSidebarLayout().then((layout) => {
        if (!cancelled) setSidebarLayout(layout);
      });
    };
    window.addEventListener('sidebarLayoutUpdated', onUpdated);
    return () => {
      cancelled = true;
      window.removeEventListener('sidebarLayoutUpdated', onUpdated);
    };
  }, []);

  const sidebarItems = React.useMemo(
    () => applySidebarLayout(baseSidebarItems, sidebarLayout),
    [baseSidebarItems, sidebarLayout],
  );
  const topMenuSidebarItems = React.useMemo(
    () => sidebarItems.filter((item) => item.name !== 'Bookmarks'),
    [sidebarItems]
  );

  // Bookmarks for top menu layout (first group). groupKey used for separators between modules.
  type BookmarkEntry = { label: string; path: string; icon?: React.ReactNode; groupKey: string };

  const [bookmarkEntries, setbookmarkEntries] = React.useState<BookmarkEntry[]>(() => {
    const cached = getCachedBookmarks();
    if (!cached || !Array.isArray(cached)) return [];
    return cached.map((fav: BookmarkItem) => ({
      label: fav.title,
      path: fav.to,
      icon: reconstructBookmarkIcon(fav, sidebarItems),
      groupKey: fav.fullPath && fav.fullPath.trim() ? fav.fullPath.split(' > ')[0].trim() : 'Bookmarks',
    }));
  });

  React.useEffect(() => {
    const loadBookmarks = async () => {
      try {
        const favs = await getBookmarks();
        setbookmarkEntries(
          (Array.isArray(favs) ? favs : []).map((fav: BookmarkItem) => ({
            label: fav.title,
            path: fav.to,
            icon: reconstructBookmarkIcon(fav, sidebarItems),
            groupKey: fav.fullPath && fav.fullPath.trim() ? fav.fullPath.split(' > ')[0].trim() : 'Bookmarks',
          }))
        );
      } catch (error) {
        console.error('Error loading bookmarks for top menu:', error);
      }
    };

    loadBookmarks();

    const handlebookmarksUpdated = () => {
      loadBookmarks();
    };

    window.addEventListener('bookmarksUpdated', handlebookmarksUpdated);
    return () => {
      window.removeEventListener('bookmarksUpdated', handlebookmarksUpdated);
    };
  }, [sidebarItems]);

  // Prefer the longest matching sidebar route so `/e-forms/builder` wins over `/e-forms`.
  const findBestSidebarMatch = (
    items: typeof sidebarItems,
    path: string,
  ): { name: string; icon?: React.ReactNode } | undefined => {
    let best: { name: string; icon?: React.ReactNode; score: number } | undefined;

    const consider = (routePath: string | undefined, name: string, icon?: React.ReactNode) => {
      if (!routePath || !name) return;
      const routeOnly = routePath.split('?')[0] || routePath;
      if (routeOnly === '/') {
        if (path === '/') best = { name, icon, score: 1 };
        return;
      }
      if (path === routeOnly || path.startsWith(`${routeOnly}/`)) {
        const score = routeOnly.length;
        if (!best || score > best.score) {
          best = { name, icon, score };
        }
      }
    };

    const walk = (nodes: typeof sidebarItems) => {
      for (const item of nodes) {
        consider(item.path, item.name, item.icon);
        for (const view of item.views ?? []) {
          consider(view.path, item.name, item.icon);
        }
        if (item.children?.length) walk(item.children);
      }
    };

    walk(items);
    return best ? { name: best.name, icon: best.icon } : undefined;
  };

  const sidebarMatch = findBestSidebarMatch(sidebarItems, location.pathname);

  // Get icon for current route
  const getIconForPath = (path: string): React.ReactNode | undefined => {
    // Custom icons for specific routes
    if (path === '/account-settings') {
      return (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      );
    }

    return findBestSidebarMatch(sidebarItems, path)?.icon;
  };
  
  // Map routes to titles
  const getPageInfo = (): { title?: string; subtitle?: string } => {
    const path = location.pathname;
    
    // Dashboard
    if (path === '/' || path === '/dashboard') {
      return { title: 'Dashboard' };
    }
    // Settings pages
    if (path === '/account-settings') {
      return { title: 'Account settings' };
    }

    if (path === '/admin/database-browser') {
      return { title: 'Database browser', subtitle: 'Inspect and edit PostgreSQL tables (admin only)' };
    }

    if (path.match(/^\/admin\/users\/\d+\/permissions$/)) {
      return { title: 'User permissions', subtitle: 'Module access for this user' };
    }

    if (path.match(/^\/admin\/users\/\d+\/menu$/)) {
      return { title: 'Customize menu', subtitle: 'Sidebar groups and shortcuts for this user' };
    }

    if (path.match(/^\/vessel-modules\/\d+\/dashboard$/)) {
      return { title: 'Vessel dashboard', subtitle: 'Vessel' };
    }

    if (path === '/admin/import-actions/impa-code') {
      return { title: 'IMPA Code', subtitle: 'Import store items from IMPA master CSV' };
    }

    if (path === '/import/invoice' || path.startsWith('/import/invoice/')) {
      return { title: 'Import Invoices' };
    }

    if (path === '/presets-management') {
      return {
        title: 'Presets Management',
      };
    }

    // Chat
    if (path === '/chat') {
      return { title: 'Chat' };
    }

    if (path === '/mga') {
      return { title: 'MGA', subtitle: "Master's General Account" };
    }

    if (path.match(/^\/supplies\/supply-cases\/\d+\/case-view$/)) {
      return { title: 'Case activity', subtitle: 'Supply case pipeline' };
    }

    if (
      path === '/port-calls' ||
      path.startsWith('/port-calls/') ||
      path === '/supplies/port-calls' ||
      path.startsWith('/supplies/port-calls/') ||
      path === '/spares/port-calls' ||
      path.startsWith('/spares/port-calls/')
    ) {
      return { title: 'Port calls' };
    }

    if (path === '/pms/hierarchy' || path.startsWith('/pms/hierarchy/')) {
      return { title: 'Equipment hierarchy' };
    }

    if (path === '/pms/due-jobs' || path.startsWith('/pms/due-jobs/')) {
      return { title: 'Due jobs' };
    }

    // Vessel-scoped requisitions (same titles as global requisitions module)
    if (path.match(/^\/vessel-modules\/\d+\/requisitions(\/|$)/)) {
      if (path.match(/^\/vessel-modules\/\d+\/requisitions\/new$/)) {
        return {
          title: requisitionsConfig.form?.new?.title || 'New requisition',
          subtitle: 'Vessel',
        };
      }
      if (path.match(/^\/vessel-modules\/\d+\/requisitions\/\d+\/edit$/)) {
        return {
          title: requisitionsConfig.form?.edit?.title || 'Edit requisition',
          subtitle: 'Vessel',
        };
      }
      if (path.match(/^\/vessel-modules\/\d+\/requisitions\/\d+$/)) {
        return { title: requisitionsConfig.module?.title || 'Supply Requisition', subtitle: 'Vessel' };
      }
      return { title: requisitionsConfig.module?.title || 'Supply Requisition', subtitle: 'Vessel' };
    }

    if (path.match(/^\/vessel-modules\/\d+\/pending-deliveries(\/|$)/)) {
      if (path.match(/^\/vessel-modules\/\d+\/pending-deliveries\/\d+$/)) {
        return { title: 'Pending delivery', subtitle: 'Vessel' };
      }
      return { title: 'Pending deliveries', subtitle: 'Vessel' };
    }

    // Find matching module config (sort by length descending to match most specific routes first)
    const sortedRoutes = Object.entries(routeToConfigMap).sort((a, b) => b[0].length - a[0].length);
    
    for (const [routePrefix, config] of sortedRoutes) {
      if (path.startsWith(routePrefix)) {
        // Check for new form
        if (path === `${routePrefix}/new` || (path.startsWith(routePrefix) && path.endsWith('/new'))) {
          const formTitle = config?.form?.new?.title;
          const moduleTitle = config?.module?.title || 'Item';
          return {
            title: formTitle || `New ${moduleTitle}`,
          };
        }
        // Check for edit form
        if (path.startsWith(routePrefix) && path.includes('/edit')) {
          const formTitle = config?.form?.edit?.title;
          const moduleTitle = config?.module?.title || 'Item';
          return {
            title: formTitle || `Edit ${moduleTitle}`,
          };
        }
        // Crew: dashboard vs full file view
        if (routePrefix === '/crew' && path.match(/^\/crew\/\d+\/file$/)) {
          const fileTitle = (config as { file?: { title?: string; subtitle?: string } })?.file?.title;
          const fileSubtitle = (config as { file?: { title?: string; subtitle?: string } })?.file?.subtitle;
          return { title: fileTitle ?? 'Crew file', subtitle: fileSubtitle };
        }
        if (routePrefix === '/crew' && path.match(/^\/crew\/\d+$/)) {
          return {
            title: 'Crew dashboard',
            subtitle: config?.detail?.subtitle ?? 'Overview',
          };
        }
        // MGA: dashboard / sheet / payslip
        if (routePrefix === '/mga' && path.match(/^\/mga\/\d+\/sheet$/)) {
          return { title: 'MGA edit', subtitle: "Master's General Account" };
        }
        if (routePrefix === '/mga' && path.match(/^\/mga\/\d+\/lines\/\d+$/)) {
          return { title: 'Monthly pay account', subtitle: 'MGA' };
        }
        if (routePrefix === '/mga' && path.match(/^\/mga\/\d+$/)) {
          return { title: 'MGA period', subtitle: "Master's General Account" };
        }
        // Check for detail view (numeric ID after route prefix)
        if (path.match(new RegExp(`^${routePrefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}/\\d+$`))) {
          return {
            title: config?.module?.title || 'Details',
          };
        }
        // Default to module title for list view
        if (path === routePrefix || path.startsWith(`${routePrefix}/`)) {
          return {
            title: config?.module?.title || 'List',
          };
        }
      }
    }
    
    return {
      title: sidebarMatch?.name,
    };
  };

  const pageInfo = getPageInfo();
  const title = pageInfo.title;
  const subtitle = pageInfo.subtitle;
  const icon = getIconForPath(location.pathname) ?? sidebarMatch?.icon;

  const { colors } = useTheme();
  const isDashboard = location.pathname === '/' || location.pathname === '/dashboard';
  /** Full-height split workspaces (COA, spare items) — avoid outer scroll so panels fill the viewport. */
  const isSplitWorkspace =
    location.pathname === '/accounting/coa' ||
    location.pathname === '/spares/spare-items' ||
    location.pathname === '/parameters/crew' ||
    location.pathname === '/parameters/general' ||
    location.pathname === '/parameters/purchasing' ||
    location.pathname === '/parameters/supplies-catalog' ||
    location.pathname === '/parameters/spares-catalog' ||
    location.pathname === '/parameters/pms' ||
    location.pathname === '/parameters/finance' ||
    location.pathname === '/parameters/crew/cert-catalogs' ||
    location.pathname === '/parameters/ports' ||
    location.pathname === '/supplies/items' ||
    location.pathname === '/accounting/statement-lines' ||
    location.pathname === '/port-calls' ||
    location.pathname === '/supplies/port-calls' ||
    location.pathname === '/spares/port-calls' ||
    location.pathname === '/pms/hierarchy' ||
    location.pathname === '/wrh/sheet' ||
    location.pathname === '/wrh/arrangements' ||
    location.pathname === '/wrh/compliance' ||
    location.pathname === '/wrh/reports' ||
    location.pathname === '/wrh/rules' ||
    location.pathname === '/vessel-operations' ||
    /^\/pms\/pms-work-orders\/\d+\/edit$/.test(location.pathname) ||
    location.pathname === '/pms/pms-work-orders/new' ||
    /^\/e-forms\/builder\/\d+$/.test(location.pathname) ||
    /^\/e-forms\/\d+\/reports(\/\d+)?$/.test(location.pathname);

  return (
    <div className={`flex h-screen ${colors.background}`}>
      <UserThemeSync />
      {showSidebar && (
        <Sidebar
          isMobileOpen={isMobileOpen}
          setIsMobileOpen={setIsMobileOpen}
          menuItems={sidebarItems}
        />
      )}
      <div
        className={cn(
          'flex-1 flex flex-col min-w-0 transition-all duration-300',
          showSidebar && 'overflow-hidden'
        )}
      >
        <Topbar
          title={title}
          subtitle={subtitle}
          icon={icon}
          isMobileMenuOpen={isMobileOpen}
          onToggleMobileMenu={() => setIsMobileOpen(!isMobileOpen)}
        />
        {showTopMenu && (
          <TopMenuNav items={topMenuSidebarItems} bookmarkEntries={bookmarkEntries} />
        )}
        <main
          className={cn(
            'flex-1 overflow-hidden min-w-0 flex flex-col',
            colors.background,
            isDashboard ? 'px-4 sm:px-6 pt-4 sm:pt-5 pb-4 sm:pb-5 w-full' : isCompact ? 'p-2 sm:p-4' : 'pt-1 px-4 pb-2'
          )}
        >
          <div className={cn(
            'flex flex-col min-w-0',
            (isDashboard || isSplitWorkspace) && 'h-full min-h-0 w-full',
            !isDashboard && !isSplitWorkspace && 'h-full min-h-0 overflow-y-auto',
            isSplitWorkspace && 'overflow-hidden'
          )}>
            <ErrorBoundary
              fallback={
                <div className="flex flex-col items-center justify-center flex-1 min-h-[320px] p-6 text-center">
                  <p className="text-gray-600 dark:text-gray-400 mb-4">Something went wrong on this page.</p>
                  <Link to="/dashboard" className="text-[#2c4a6e] dark:text-[#9bb4d0] hover:underline">Back to Dashboard</Link>
                </div>
              }
            >
              <ModuleGuard>{children}</ModuleGuard>
            </ErrorBoundary>
          </div>
        </main>
        {appConfig.features.enableFooter && <Footer />}
      </div>
    </div>
  );
};

export default MainLayout;
